export default __webpack_public_path__ + "static/media/UploadButton.17ceaf71.less";